// extracted by mini-css-extract-plugin
module.exports = {"container":"forgot-password_container__OejTS","backtolink":"forgot-password_backtolink__jjLMU","loadingIndicator":"forgot-password_loadingIndicator__GWL9n"};